import { render, staticRenderFns } from "./Fancybox.vue?vue&type=template&id=612aab85"
import script from "./Fancybox.vue?vue&type=script&lang=js"
export * from "./Fancybox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.6.14_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports